import { IProfileFieldConstraintsMap, WorkerProfileField } from 'types';
import * as Yup from 'yup';
import { shouldEnforceFieldAsMandatory } from 'utils/skippableFieldsUtils';

const tradesSchema = (
  t: any,
  profileFieldConstraintsMap: IProfileFieldConstraintsMap,
  hasReachedConsentForm: boolean = false,
  otherTradesId?: string,
) => {
  const isMandatory = {
    role: shouldEnforceFieldAsMandatory(
      WorkerProfileField.workerRole,
      profileFieldConstraintsMap,
      hasReachedConsentForm,
    ),
    laborUnion: shouldEnforceFieldAsMandatory(
      WorkerProfileField.workerLaborUnionStatus,
      profileFieldConstraintsMap,
      hasReachedConsentForm,
    ),
    workExperience: shouldEnforceFieldAsMandatory(
      WorkerProfileField.workerWorkExperience,
      profileFieldConstraintsMap,
      hasReachedConsentForm,
    ),
    laborUnionNumber: shouldEnforceFieldAsMandatory(
      WorkerProfileField.workerLaborUnionNumber,
      profileFieldConstraintsMap,
      hasReachedConsentForm,
    ),
    trades: shouldEnforceFieldAsMandatory(
      WorkerProfileField.workerTrades,
      profileFieldConstraintsMap,
      hasReachedConsentForm,
    ),
  };
  return Yup.object().shape({
    isSupervisor: isMandatory.role
      ? Yup.boolean().nullable().required(t('trades.errors.roleRequired')).typeError(t('trades.errors.roleRequired'))
      : Yup.boolean().nullable(),

    isAffiliatedToLaborUnion: isMandatory.laborUnion
      ? Yup.boolean()
          .nullable()
          .required(t('trades.errors.laborUnionRequired'))
          .typeError(t('trades.errors.laborUnionRequired'))
      : Yup.boolean().nullable(),

    isSkilled: isMandatory.workExperience
      ? Yup.boolean()
          .nullable()
          .required(t('trades.errors.workExperienceRequired'))
          .typeError(t('trades.errors.workExperienceRequired'))
      : Yup.boolean().nullable(),

    laborUnionNumber: Yup.string().when('isAffiliatedToLaborUnion', {
      is: (isAffiliatedToLaborUnion: boolean) => isAffiliatedToLaborUnion === true,
      then: schema =>
        isMandatory.laborUnionNumber
          ? schema
              .required(t('trades.errors.laborUnionNumberRequired'))
              .min(3, t('trades.errors.laborUnionNumberMin'))
              .max(20, t('trades.errors.laborUnionNumberMax'))
          : schema.min(3, t('trades.errors.laborUnionNumberMin')).max(20, t('trades.errors.laborUnionNumberMax')),
      otherwise: schema => schema.notRequired(),
    }),

    trades: isMandatory.trades
      ? Yup.array()
          .of(Yup.string().required())
          .required(t('trades.errors.selectedTradesRequired'))
          .test('has-real-trade', t('trades.errors.selectedTradesMinimum'), function (trades) {
            const otherTradesList: Array<{ OtherText: string }> = this.parent.otherTradesList || [];
            const realMasterTrades = (trades || []).filter(id => id !== otherTradesId);
            return realMasterTrades.length > 0 || otherTradesList.length > 0;
          })
      : Yup.array().of(Yup.string()),

    otherTradesList: Yup.array()
      .of(
        Yup.object().shape({
          isSaved: Yup.boolean().required(),
          OtherText: Yup.string().required().max(100, t('trades.errors.otherTradeMax')),
        }),
      )
      .default([]),
  });
};

export default tradesSchema;
